import { useState } from "react";
import type { Episode } from "@/types/media";

interface EpisodeListProps {
  episodes: Episode[];
  updatedTo: number;
}

export default function EpisodeList({ episodes, updatedTo }: EpisodeListProps) {
  const [activeNo, setActiveNo] = useState(episodes[0]?.no ?? 1);
  const active = episodes.find((ep) => ep.no === activeNo) ?? episodes[0];

  return (
    <section className="w-full px-4 md:px-8 pb-10 md:pb-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-5">
          <span className="w-1.5 h-7 rounded-full bg-primary-500" aria-hidden="true" />
          <h2 className="font-heading text-xl md:text-2xl font-semibold uppercase text-foreground-950">剧集目录</h2>
          <span className="text-sm text-foreground-500">已更新 {updatedTo} 集</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 rounded-lg bg-background-100 ring-1 ring-background-200/70 p-5">
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex items-center justify-center rounded-md bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                第 {active.no} 集
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950">{active.title}</h3>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">{active.summary}</p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-information-line text-accent-400" aria-hidden="true" />
              本页仅展示剧集简介信息，不提供实际在线播放功能。
            </div>
          </div>

          <div className="rounded-lg bg-background-100 ring-1 ring-background-200/70 p-4">
            <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-4 gap-2 max-h-80 lg:max-h-96 overflow-y-auto pr-1">
              {episodes.map((ep) => (
                <button
                  key={ep.no}
                  type="button"
                  onClick={() => setActiveNo(ep.no)}
                  className={`h-10 rounded-md text-sm transition-colors cursor-pointer ${
                    ep.no === activeNo
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200/70 text-foreground-400 hover:text-accent-300 hover:bg-background-300/60"
                  }`}
                >
                  {ep.no}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}